import classNames from 'classnames';
import Skeleton from 'react-loading-skeleton';

import styles from './skeleton.module.scss';

export const CardSkeleton = () => (
  <li className={classNames(styles.planCard, styles.skeletonCard)}>
    <div className={styles.skeletonWrapper}>
      <Skeleton count={1} height={25} className={styles.titleSkeleton} />
      <Skeleton count={1} className={styles.descriptionSkeleton} />
    </div>
  </li>
);
